module.exports = __webpack_public_path__ + "static/media/1 cleopatra color egyptian  pyramid.1187x1725.db861df6.webp";